import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startTrainingProgram } from '../../../redux/slices/customer/trainingSlice';
import 'react-confirm-alert/src/react-confirm-alert.css';
import showAlert from '../../../components/common/showAlert';
import { updateWeekAndDay } from '../../../redux/slices/protectSlice';

const ProgramListModal = ({ isOpen, onClose, selectedUser }) => {
  const dispatch = useDispatch();
  const { programs_minimal } = useSelector((state) => state.admin_clients);

  // State to handle search input
  const [searchTerm, setSearchTerm] = useState('');

  // Handle program selection
  const handleProgramSelect = (programId) => {

    var p = {"latest_week":1, "latest_day":1}
    dispatch(updateWeekAndDay(p));

    const payload = { training_program_id: programId, user_id: selectedUser.id };
    dispatch(startTrainingProgram(payload));
    showAlert('success', 'Program has been changed for the selected client');
    onClose();
  };

  // Filter programs based on search input
  const filteredPrograms = programs_minimal
    ? programs_minimal.filter((program) =>
        program.program_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block assignProgramModal"
      id="modalProgram"
      tabIndex="-1"
      aria-labelledby="modalProgramLabel"
      aria-hidden="true"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <div className="w-100">
              <h1 className="modal-title" id="modalProgramLabel">
                Assign Program
              </h1>
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div
            className="modal-body px-md-5 pb-md-4"
            style={{
              maxHeight: '70vh',
              overflowY: 'auto',
              paddingRight: '5px',
            }}
          >
            {/* Search Field */}
            
             
           

            {/* Programs Table */}
            <div className="row g-3 gx-md-5 gy-md-4">

             <input
                type="text"
                className="form-control w-100 search-program"
                placeholder="Search Programs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              
              {filteredPrograms.length > 0 ? (
                <table
                  className="table table-striped table-bordered w-100"
                  style={{ tableLayout: 'fixed' }}
                >
                  <thead>
                    <tr>
                      <th className="text-start" style={{ width: '30%' }}>
                        Program Name
                      </th>
                      <th>Gender</th>
                      <th>Weeks</th>
                      <th>Days/Week</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPrograms.map((program) => (
                      <tr key={program.id}>
                        <td className="text-start">{program.program_name}</td>
                        <td>{program.gender}</td>
                        <td>{program.weeks}</td>
                        <td>{program.days}</td>
                        <td>
                          <button
                            className="btn btn-create choose-btn w-100"
                            onClick={() => handleProgramSelect(program.id)}
                          >
                            Choose
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-center">No Programs Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramListModal;
